import React from 'react'
import ReactDOM from 'react-dom'
import { Toaster } from 'react-hot-toast'
import 'react-app-polyfill/ie11'

import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'

import { Header, Footer } from './components'
import HomeScreen from './screens/Home'
import initCookieBannerService from './service/CookieBanner'
import ModuleScreen from './screens/Modules'
import './assets/sass/main.scss'
import store from './redux/store'
import { IdContextProvider } from './contexts/IdContext'

initCookieBannerService()

const Navigation = () => (
  <Router basename={`${process.env.REACT_APP_SUBFOLDER}`}>
    <Header />
    <Toaster />
    <Routes>
      <Route path="/" element={<HomeScreen />} />
      <Route path="/modules" element={<ModuleScreen />} />
      <Route path="*" element={<HomeScreen />} />
    </Routes>
    <Footer />
  </Router>
)

const Root = ({ store }) => (
  <Provider store={store}>
    <IdContextProvider>
      <Navigation />
    </IdContextProvider>
  </Provider>
)

ReactDOM.render(<Root store={store} />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()